<span #container [wchfsTooltip]="container.offsetWidth < container.scrollWidth ? extraContent + content : undefined">{{
  content || '-'
}}</span>
